

















import { Component, Prop, Vue } from "vue-property-decorator";

import { Campaign } from "@/models/definitions";

@Component
export default class CampaignCard extends Vue {
  @Prop({ required: true }) readonly campaign!: Campaign;
  @Prop({ default: "campaign" }) readonly linkName!: string;
  @Prop({ default: "Zur Aufgabenübersicht" }) readonly linkText!: string;
}
